import { getDefaultValueForFilter } from './get_default_value_for_filter';

function getDefaultValueForFilters(filters) {
    return filters.reduce((acc, curFilter) => {
        acc[curFilter] = getDefaultValueForFilter(curFilter);
        return acc;
    }, {});
}

export { getDefaultValueForFilters };